import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getQueryParams = () => new URLSearchParams(location.search);

  const getQueryParam = (key: string) => getQueryParams().get(key);

  const setQueryParams = useCallback(
    (params: Record<string, string | undefined>) => {
      const queryParams = new URLSearchParams(location.search);
      Object.entries(params).forEach(([key, value]) => {
        if (value) {
          queryParams.set(key, value);
        } else {
          queryParams.delete(key);
        }
      });
      navigate(`${location.pathname}?${queryParams.toString()}`, {
        replace: true,
      });
    },
    [location.pathname, location.search, navigate]
  );

  return { getQueryParam, setQueryParams };
};

export default useQueryParams;
